import { EventsCalendarContext } from '../context'
import { TextField, MenuItem } from '@mui/material'
import { useState, useCallback, useContext } from 'react'

function HeaderSelect(props) {
  const { hideOptionList } = props
  const { eventsMode, setEventsMode } = useContext(EventsCalendarContext)

  const listViewTypes = [
    {
      key: 'Dia',
      active: true,
    },
  ]

  if (hideOptionList == undefined || !hideOptionList) {
    listViewTypes.push({
      key: 'Lista',
      active: false,
    })
  }

  const [mode, setMode] = useState(listViewTypes)

  const handleChangeMode = useCallback((type) => {
    setMode((prevState) => {
      const updatedData = prevState.map((item) => {
        if (item.key === type) {
          setEventsMode(item.key)
          return { ...item, active: true }
        }
        return { ...item, active: false }
      })

      return updatedData
    })
  }, [])

  return (
    <TextField
      select
      size="tiny"
      value={eventsMode}
      onChange={(e) => {
        handleChangeMode(e.target.value)
      }}
      sx={{ width: '100px',
        backgroundColor: 'white',
        [`& .MuiSelect-select`]: {
          color: '#606162',
        },
        marginRight: 'auto',
       }}
    >
      {mode.map((option) => (
        <MenuItem
          key={option.key}
          value={option.key}
          sx={{ fontSize: '12px', color: '#606162' }}
        >
          {option.key}
        </MenuItem>
      ))}
    </TextField>
  )
}

export { HeaderSelect }
